import {createSlice, PayloadAction, createSelector} from '@reduxjs/toolkit';
import type {RootState} from '../../types';
import type {ICategoriesState, ICategory} from './types';

const categoriesSelector = (state: RootState) => state.categories.data;

const lastUpdateSelector = (state: RootState) => state.categories.lastUpdate;

export const categoriesSlice = createSlice({
	name: 'categories',
	initialState: {
		lastUpdate: 0,
		data: {},
		cacheKey: null
	} as ICategoriesState,
	reducers: {
		receiveCacheKey: (state: ICategoriesState, action: PayloadAction<string | null>) => {
			state.cacheKey = action.payload;
		},
		receiveCategory: (state: ICategoriesState, action: PayloadAction<ICategory>) => {
			const data = Object.assign(state.data, {[action.payload.id]: action.payload});
			const newState: {data: typeof data; lastUpdate?: number} = {data};

			if (action.payload.id === 'root') {
				newState.lastUpdate = Date.now();
			}

			Object.assign(state, newState);
		},
		receiveCategories: (state: ICategoriesState, action: PayloadAction<Record<string, ICategory> | ICategory[]>) => {
			const data = Object.assign(state.data, action.payload as any);
			const newState: {data: typeof data; lastUpdate?: number} = {data};

			if ('root' in (action.payload as any)) {
				newState.lastUpdate = Date.now();
			}

			Object.assign(state, newState);
		},
		markToBeRefreshed: (state: ICategoriesState, action: PayloadAction<string>) => {
			const newState = Object.assign({}, state);

			newState.data[action.payload].toBeRefreshed = true;

			return newState;
		},
	},
});

export const {receiveCategory, markToBeRefreshed, receiveCategories, receiveCacheKey} = categoriesSlice.actions;

export const selectLastUpdate = createSelector(lastUpdateSelector, (lastUpdate) => lastUpdate);

export const selectCategories = createSelector(categoriesSelector, (categories) => categories);

export const selectCategory = createSelector(
	[selectCategories, (_, cgid: string) => cgid],
	(categories, categoryId) => categories[categoryId]);

export default categoriesSlice.reducer;
